export default __webpack_public_path__ + "static/media/reunion22_w1024.824ed3b3.jpg";